// @flow
export const SEATING_OPTIONS = {
  PARTICULAR_SEAT: "particular_seat",
  WINDOW: "window",
  AISLE: "aisle",
  EXTRA_LEGROOM: "extra_legroom",
  SIT_TOGETHER: "sit_together",
}
